import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/lib/auth";
import { useFeatures } from "@/lib/features";
import {
  Plus, UserPlus, ListTodo, FolderKanban, Megaphone, CalendarCheck,
  Building2, MapPin, Laptop, CalendarDays, Video, Wallet,
} from "lucide-react";

export default function CreateMenu() {
  const nav = useNavigate();
  const { user } = useAuth();
  const { isModuleOn } = useFeatures();
  const isAdmin = ["super_admin", "hr_admin"].includes(user?.role);
  const isFinance = isAdmin || user?.role === "finance";

  const goto = (path, state) => nav(path, state ? { state } : undefined);

  const items = [];
  if (isAdmin && isModuleOn("people")) items.push({ key: "emp", label: "Employee", icon: UserPlus, to: "/people", state: { openAdd: true }, testid: "create-employee" });
  if (isAdmin && isModuleOn("organization")) {
    items.push({ key: "dept", label: "Department / Designation", icon: Building2, to: "/organization" });
    items.push({ key: "branch", label: "Branch / Location", icon: MapPin, to: "/organization" });
  }
  if (isAdmin && isModuleOn("holidays")) items.push({ key: "hol", label: "Holiday", icon: CalendarDays, to: "/holidays" });
  if (isAdmin && isModuleOn("announcements")) items.push({ key: "ann", label: "Announcement", icon: Megaphone, to: "/announcements" });
  if (isAdmin && isModuleOn("assets")) items.push({ key: "ast", label: "Asset", icon: Laptop, to: "/assets", state: { openAdd: true } });
  if (isFinance && isModuleOn("payroll")) items.push({ key: "pay", label: "Payroll Period", icon: Wallet, to: "/payroll", state: { openAdd: true } });

  const userItems = [];
  if (isModuleOn("tasks")) userItems.push({ key: "task", label: "Task", icon: ListTodo, to: "/tasks", state: { openAdd: true }, testid: "create-task" });
  if (isModuleOn("leaves")) userItems.push({ key: "lv", label: "Leave request", icon: CalendarCheck, to: "/leaves", state: { openAdd: true } });
  if (isModuleOn("projects")) userItems.push({ key: "proj", label: "Project", icon: FolderKanban, to: "/projects" });
  if (isModuleOn("meetings")) userItems.push({ key: "mt", label: "Meeting", icon: Video, to: "/meetings", state: { openAdd: true } });

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2" data-testid="create-btn">
          <Plus className="w-4 h-4"/><span className="hidden sm:inline">Create</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Quick create</DropdownMenuLabel>
        <DropdownMenuSeparator/>
        {items.map((it) => (
          <DropdownMenuItem key={it.key} onClick={() => goto(it.to, it.state)} data-testid={it.testid}>
            <it.icon className="w-4 h-4 mr-2"/>{it.label}
          </DropdownMenuItem>
        ))}
        {items.length > 0 && userItems.length > 0 && <DropdownMenuSeparator/>}
        {userItems.map((it) => (
          <DropdownMenuItem key={it.key} onClick={() => goto(it.to, it.state)} data-testid={it.testid}>
            <it.icon className="w-4 h-4 mr-2"/>{it.label}
          </DropdownMenuItem>
        ))}
        {items.length + userItems.length === 0 && (
          <div className="px-3 py-2 text-xs text-slate-500">No quick actions available</div>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
